'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var actionTypes = require('./actionTypes.js');

var reducers = function (state, action) {
    switch (action.type) {
        case actionTypes.ActionTypes.FILTER_LIST:
            return tslib.__assign(tslib.__assign({}, state), { filter: action.filter });
        case actionTypes.ActionTypes.SORT_LIST: {
            var newDirection = action.sortBy === state.sortBy && state.sortDirection
                ? state.sortDirection * -1
                : action.sortDirection === 1 || action.sortDirection === -1
                    ? action.sortDirection
                    : 1;
            return tslib.__assign(tslib.__assign({}, state), { sortBy: action.sortBy, sortDirection: newDirection, sortType: action.sortType });
        }
        case actionTypes.ActionTypes.SET_CURRENT_PAGE: {
            return tslib.__assign(tslib.__assign({}, state), { currentPage: action.currentPage, pageRecords: action.pageRecords });
        }
        case actionTypes.ActionTypes.SET_ITEMS_PER_PAGE:
            return tslib.__assign(tslib.__assign({}, state), { itemsPerPage: action.itemsPerPage });
        default:
            return state;
    }
};
var reducer = reducers;

exports.default = reducer;
//# sourceMappingURL=reducers.js.map
